<!-- Image en 260 px de large pour 130 px affichés : nette sur les écrans 2x. -->
<img src="/assets/loaders/loading_carrot_color_nobg_resized.webp" width="130" height="193" alt="">
